import logo from "../icon.png";
import React from "react";

function Header() {

    return (
        <>
            <style>{`
            
                .main-div{
                    display: flex;
                    width: 100%;
                    flex-direction: row;
                }
                
                .left-div{
                    display: flex;
                    flex: 1;
                    flex-direction: row;
                    justify-content: center;
                    gap: 20px;
                    padding-right: 10px;
                    place-items: center;
                
                }
                .right-div{
                    flex: 1;
                    place-content: center;
                
                }
                
                .App-header {
                /*    background-color: #282c34;*/
                    width: 100%;
                    height: 80px;
                    background: linear-gradient(to right, #222222, #393939);
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    font-size: calc(10px + 2vmin);
                    color: white;
                }

                .App-logo {
                    height: 30px;

                }
                .span {
                    color: #61dafb;
                    font-weight: bold;
                }
            
            `}</style>
        <header className="App-header">
            <div className="main-div">
                <div className="left-div">
                    <img src={logo} className="App-logo" alt="logo" />
                    <p> Image<span className="span">Converter</span></p>
                </div>
                <div className="right-div">Under The build</div>
            </div>
        </header>
        </>

    );
}

export default Header;